import React, { useState } from "react";
import { Tabs } from "antd";
import PedigreeMatrix from "./PedigreeMatrix";
import PedigreeCertificate from "./PedigreeCertificate";
import AnimalPhotos from "views/console/animal-inventory/components/AnimalPhotos";

const AnimalTab = ({ recordId }) => {

  const items = [
    { key: "photos", label: "Photos", children: <AnimalPhotos recordId={recordId}/> },
    { key: "lineage", label: "Lineage", children: <PedigreeMatrix recordId={recordId}/> },
    { key: "certificate", label: "Certificate", children: <PedigreeCertificate/> },
  ];

  return <Tabs type="card" items={items} />;
};

export default AnimalTab;
